import api from './api';

const loyaltyService = {
  // Get user points
  async getUserPoints() {
    try {
      const response = await api.get('/members/points');
      return response.data;
    } catch (error) {
      console.error('Get user points error:', error);
      throw error;
    }
  },

  // Get group details
  async getGroupDetails(groupId) {
    try {
      const response = await api.get(`/members/group/${groupId}`);
      return response.data;
    } catch (error) {
      console.error('Get group details error:', error);
      throw error;
    }
  },

  // Get user transaction history
  async getTransactionHistory() {
    try {
      const response = await api.get('/loyalty/transactions');
      return response.data;
    } catch (error) {
      console.error('Get transaction history error:', error);
      throw error;
    }
  },

  // Get available rewards
  async getAvailableRewards() {
    try {
      const response = await api.get('/loyalty/rewards');
      return response.data;
    } catch (error) {
      console.error('Get rewards error:', error);
      throw error;
    }
  },

  // Redeem a reward
  async redeemReward(rewardId) {
    try {
      const response = await api.post('/loyalty/redeem', { rewardId });
      return response.data;
    } catch (error) {
      console.error('Redeem reward error:', error);
      throw error;
    }
  },

  // Redeem a coupon
  async redeemCoupon(groupId, couponId, customerCouponId) {
    try {
      const params = { group_id: groupId };
      if (customerCouponId) {
        params.customer_coupon_id = customerCouponId;
      } else {
        params.coupon_id = couponId;
      }

      const response = await api.post('/members/redeem', params);
      return response.data;
    } catch (error) {
      console.error('Redeem coupon error:', error);
      throw error;
    }
  },

  // Leave a loyalty program
  async leaveProgram(groupId) {
    try {
      const response = await api.post('/members/leave', { group_id: groupId });
      return response.data;
    } catch (error) {
      console.error('Leave program error:', error);
      throw error;
    }
  },

  // Get public group info (no auth required)
  async getPublicGroupInfo(groupId) {
    try {
      const response = await api.get(`/groups/${groupId}/public`);
      return response.data;
    } catch (error) {
      console.error('Get public group info error:', error);
      throw error;
    }
  },
  
  // Public phone enrollment (no auth required)
  async publicPhoneEnroll(id, phone) {
    try {
      const response = await api.post(`/groups/${id}/enroll`, { phone });
      return response.data;
    } catch (error) {
      console.error('Public phone enroll error:', error);
      throw error;
    }
  },
};

export default loyaltyService;